import {useContext, useState, useEffect} from 'react'

// import {NotificationBox} from '../../components/NotificationBox'

import newLogo from '../../assets/img/newLogo.svg'
import avatarnew from '../../assets/img/avatarnew.svg'
import {AuthContext} from '../../context'
import {Link, useNavigate} from 'react-router-dom'

export const Header = () => {
	const [active, setActive] = useState(false)
	const {logout, authState} = useContext(AuthContext)
	const navigate = useNavigate()

	const handleDocumentClick = (event, id) => {
		const menuElement = document.getElementById("headerNewMenu");
		if (menuElement && menuElement.contains(event.target)) {
        	return;
    	}

		const targetId = event.target.id;
	  
		if (targetId !== "burgerMenu" && targetId !== "headerNewMenu"
			&& targetId !== "leftSideMenu"
			&& targetId !== "svgBurgerMenu"
			&& targetId !== "pathBurgerMenu"
			&& targetId !== "inicioMenu"
			&& targetId !== "cierreSesionMenu"
			&& targetId !== "menuHistorial"
			&& targetId !== "menu_wrapper"
			&& targetId !== "menuEvaluacion"
			&& targetId !== "icon_wrapper"
			&& targetId !== "menuEvaluacionp"
			&& targetId !== "menuHistorialp"
			&& targetId !== "menuPerfil"
			&& targetId !== "menuPerfilImg"
			&& targetId !== "menuPerfilSvg"
			&& targetId !== "menuPerfilNombre"
			&& targetId !== "menuPerfilFlecha"
			&& targetId !== "mask0_552_306041"
			&& targetId !== "menuPlanificacion"
			&& targetId !== "menuPlanificacionp"
			&& targetId !== "menuMantenedor"
			&& targetId !== "menuMantenedorp"
			&& targetId !== "menuBuscador"
			&& targetId !== "menuBuscadorp"
			&& targetId !== "menuPanelPenetraciones"
			&& targetId !== "menuPanelPenetracionesp"
			&& targetId !== "menuForecast"
			&& targetId !== "menuForecastp"
		) {
			setActive(false);
		  }
	  };

	  useEffect(() => {
		const handleClick = (event) => handleDocumentClick(event);
		
		document.addEventListener("mousedown", handleClick);
		
		return () => {
			document.removeEventListener("mousedown", handleClick);
		};
	}, []);

	return (
		<div className='HeaderNew' id={"headerNewMenu"}>
			<div className='left_side' id={"leftSideMenu"}>
				<div
					className={`burger_icon ${active === 'first' && 'active'}`}
					onClick={(e) => {
						e.stopPropagation();
						setActive(active === 'first' ? false : 'first')
					}}
					id={"burgerMenu"}
				>
					<svg
						width='16'
						height='16'
						viewBox='0 0 24 14'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
						id="svgBurgerMenu"
					>
						<path
							d='M1.42105 8.42105C1.02105 8.42105 0.684211 8.28421 0.410526 8.01052C0.136842 7.73684 0 7.4 0 7C0 6.57894 0.136842 6.23158 0.410526 5.95789C0.684211 5.68421 1.02105 5.54737 1.42105 5.54737H14.8105C15.2105 5.54737 15.5528 5.68421 15.8375 5.95789C16.1213 6.23158 16.2632 6.57894 16.2632 7C16.2632 7.4 16.1213 7.73684 15.8375 8.01052C15.5528 8.28421 15.2105 8.42105 14.8105 8.42105H1.42105ZM1.42105 13.7263C1.02105 13.7263 0.684211 13.584 0.410526 13.2994C0.136842 13.0156 0 12.6737 0 12.2737C0 11.8737 0.136842 11.5318 0.410526 11.248C0.684211 10.9634 1.02105 10.8211 1.42105 10.8211H22.5789C22.9789 10.8211 23.3158 10.9634 23.5895 11.248C23.8632 11.5318 24 11.8737 24 12.2737C24 12.6737 23.8632 13.0156 23.5895 13.2994C23.3158 13.584 22.9789 13.7263 22.5789 13.7263H1.42105ZM1.42105 3.14737C1.02105 3.14737 0.684211 3.01052 0.410526 2.73684C0.136842 2.46316 0 2.11579 0 1.69473C0 1.29473 0.136842 0.957892 0.410526 0.684208C0.684211 0.410524 1.02105 0.273682 1.42105 0.273682H22.5789C22.9789 0.273682 23.3158 0.410524 23.5895 0.684208C23.8632 0.957892 24 1.29473 24 1.69473C24 2.11579 23.8632 2.46316 23.5895 2.73684C23.3158 3.01052 22.9789 3.14737 22.5789 3.14737H1.42105Z'
							fill='#3676F5'
							id="pathBurgerMenu"
						/>
					</svg>
				</div>
				{active === 'first' && (
					<div className='menu_wrapper'>
						<Link
							to={'/HomeNew'}
							onClick={() => setActive(active === 'first' ? false : 'first')}
							
						>
							<div className='icon_wrapper'>
								<svg
									width='12'
									height='12'
									viewBox='0 0 12 12'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_570539'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='12'
										height='12'
									>
										<rect width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_570539)'>
										<path
											d='M3.0374 9.4626H4.4249V6.4251H7.5749V9.4626H8.9624V5.0126L5.9999 2.8001L3.0374 5.0126V9.4626ZM3.0374 10.6001C2.72074 10.6001 2.45207 10.4898 2.2314 10.2691C2.0104 10.0481 1.8999 9.77926 1.8999 9.4626V5.0126C1.8999 4.8376 1.93957 4.66876 2.0189 4.5061C2.0979 4.34376 2.20824 4.2126 2.3499 4.1126L5.3124 1.8876C5.42074 1.8126 5.53124 1.75626 5.6439 1.7186C5.75624 1.68126 5.8749 1.6626 5.9999 1.6626C6.1249 1.6626 6.24374 1.68126 6.3564 1.7186C6.46874 1.75626 6.57907 1.8126 6.6874 1.8876L9.6499 4.1126C9.79157 4.2126 9.90207 4.34376 9.9814 4.5061C10.0604 4.66876 10.0999 4.8376 10.0999 5.0126V9.4626C10.0999 9.77926 9.98957 10.0481 9.7689 10.2691C9.5479 10.4898 9.27907 10.6001 8.9624 10.6001H6.4749V7.5251H5.5249V10.6001H3.0374Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>

							<p style={{flex: 1}} id={"inicioMenu"}
							onClick={(e) => {
								window.location.pathname = '/HomeNew'
							}}>Inicio</p>

							{/* <span className="label_header">
                Label
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_201_800919"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_201_800919)">
                    <path
                      d="M5.87419 17.6666C5.65196 17.4305 5.54085 17.1561 5.54085 16.8433C5.54085 16.5311 5.65196 16.2569 5.87419 16.0208L11.895 9.99996L5.85335 3.95829C5.63113 3.73607 5.52002 3.46524 5.52002 3.14579C5.52002 2.82635 5.63808 2.54857 5.87419 2.31246C6.09641 2.09024 6.36724 1.97913 6.68669 1.97913C7.00613 1.97913 7.28391 2.09024 7.52002 2.31246L14.52 9.33329C14.6172 9.43051 14.6867 9.53468 14.7284 9.64579C14.77 9.7569 14.7909 9.87496 14.7909 9.99996C14.7909 10.125 14.77 10.243 14.7284 10.3541C14.6867 10.4652 14.6172 10.5694 14.52 10.6666L7.49919 17.6875C7.27696 17.9097 7.00946 18.0208 6.69669 18.0208C6.38446 18.0208 6.1103 17.9027 5.87419 17.6666Z"
                      fill="#3676F5"
                    />
                  </g>
                </svg>
              </span> */}
						</Link>
						{ /* <a href='/CatalogSearch' id={"menuBuscador"}>
							
							<div className='icon_wrapper'>
								<svg
									width='12'
									height='12'
									viewBox='0 0 12 12'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_570960'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='12'
										height='12'
									>
										<rect width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_570960)'>
										<path
											d='M7.23691 8.00015C7.33691 8.10015 7.45991 8.15015 7.60591 8.15015C7.75158 8.15015 7.87858 8.09598 7.98692 7.98765C8.08692 7.88765 8.13691 7.76048 8.13691 7.60615C8.13691 7.45215 8.08692 7.32515 7.98692 7.22515L6.54941 5.77515V4.05015C6.54941 3.89181 6.49741 3.76265 6.39341 3.66265C6.28908 3.56265 6.15775 3.51265 5.99941 3.51265C5.84108 3.51265 5.70991 3.56465 5.60591 3.66865C5.50158 3.77298 5.44941 3.90431 5.44941 4.06265V5.97515C5.44941 6.05015 5.46408 6.12298 5.49341 6.19365C5.52241 6.26465 5.56608 6.32931 5.62441 6.38765L7.23691 8.00015ZM5.99941 11.1001C5.29108 11.1001 4.62641 10.9668 4.00541 10.7001C3.38475 10.4335 2.84525 10.071 2.38691 9.61265C1.92858 9.15431 1.56608 8.61481 1.29941 7.99415C1.03275 7.37315 0.899414 6.70848 0.899414 6.00015C0.899414 5.29181 1.03275 4.62715 1.29941 4.00615C1.56608 3.38548 1.92858 2.84598 2.38691 2.38765C2.84525 1.92931 3.38475 1.56681 4.00541 1.30015C4.62641 1.03348 5.29108 0.900146 5.99941 0.900146C6.70775 0.900146 7.37241 1.03348 7.99341 1.30015C8.61408 1.56681 9.15358 1.92931 9.61192 2.38765C10.0702 2.84598 10.4327 3.38548 10.6994 4.00615C10.9661 4.62715 11.0994 5.29181 11.0994 6.00015C11.0994 6.70848 10.9661 7.37315 10.6994 7.99415C10.4327 8.61481 10.0702 9.15431 9.61192 9.61265C9.15358 10.071 8.61408 10.4335 7.99341 10.7001C7.37241 10.9668 6.70775 11.1001 5.99941 11.1001ZM5.99941 9.96265C7.09941 9.96265 8.03492 9.57731 8.80592 8.80665C9.57658 8.03565 9.96192 7.10015 9.96192 6.00015C9.96192 4.90015 9.57658 3.96465 8.80592 3.19365C8.03492 2.42298 7.09941 2.03765 5.99941 2.03765C4.89941 2.03765 3.96408 2.42298 3.19341 3.19365C2.42241 3.96465 2.03691 4.90015 2.03691 6.00015C2.03691 7.10015 2.42241 8.03565 3.19341 8.80665C3.96408 9.57731 4.89941 9.96265 5.99941 9.96265Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>
							<p
							onClick={(e) => {
								window.location.pathname = '/CatalogSearch'
							}} id={"menuBuscadorp"}
							>Buscador Promocional</p>
						</a>
						*/ }
						<a href='/Dashboard/planificacion' id={"menuPlanificacion"}>
							
							<div className='icon_wrapper'>
								<svg
									width='12'
									height='12'
									viewBox='0 0 12 12'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_570960'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='12'
										height='12'
									>
										<rect width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_570960)'>
										<path
											d='M7.23691 8.00015C7.33691 8.10015 7.45991 8.15015 7.60591 8.15015C7.75158 8.15015 7.87858 8.09598 7.98692 7.98765C8.08692 7.88765 8.13691 7.76048 8.13691 7.60615C8.13691 7.45215 8.08692 7.32515 7.98692 7.22515L6.54941 5.77515V4.05015C6.54941 3.89181 6.49741 3.76265 6.39341 3.66265C6.28908 3.56265 6.15775 3.51265 5.99941 3.51265C5.84108 3.51265 5.70991 3.56465 5.60591 3.66865C5.50158 3.77298 5.44941 3.90431 5.44941 4.06265V5.97515C5.44941 6.05015 5.46408 6.12298 5.49341 6.19365C5.52241 6.26465 5.56608 6.32931 5.62441 6.38765L7.23691 8.00015ZM5.99941 11.1001C5.29108 11.1001 4.62641 10.9668 4.00541 10.7001C3.38475 10.4335 2.84525 10.071 2.38691 9.61265C1.92858 9.15431 1.56608 8.61481 1.29941 7.99415C1.03275 7.37315 0.899414 6.70848 0.899414 6.00015C0.899414 5.29181 1.03275 4.62715 1.29941 4.00615C1.56608 3.38548 1.92858 2.84598 2.38691 2.38765C2.84525 1.92931 3.38475 1.56681 4.00541 1.30015C4.62641 1.03348 5.29108 0.900146 5.99941 0.900146C6.70775 0.900146 7.37241 1.03348 7.99341 1.30015C8.61408 1.56681 9.15358 1.92931 9.61192 2.38765C10.0702 2.84598 10.4327 3.38548 10.6994 4.00615C10.9661 4.62715 11.0994 5.29181 11.0994 6.00015C11.0994 6.70848 10.9661 7.37315 10.6994 7.99415C10.4327 8.61481 10.0702 9.15431 9.61192 9.61265C9.15358 10.071 8.61408 10.4335 7.99341 10.7001C7.37241 10.9668 6.70775 11.1001 5.99941 11.1001ZM5.99941 9.96265C7.09941 9.96265 8.03492 9.57731 8.80592 8.80665C9.57658 8.03565 9.96192 7.10015 9.96192 6.00015C9.96192 4.90015 9.57658 3.96465 8.80592 3.19365C8.03492 2.42298 7.09941 2.03765 5.99941 2.03765C4.89941 2.03765 3.96408 2.42298 3.19341 3.19365C2.42241 3.96465 2.03691 4.90015 2.03691 6.00015C2.03691 7.10015 2.42241 8.03565 3.19341 8.80665C3.96408 9.57731 4.89941 9.96265 5.99941 9.96265Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>
							<p
							onClick={(e) => {
								window.location.pathname = '/Dashboard/planificacion'
							}} id={"menuPlanificacionp"}
							>Planificación Promocional</p>
						</a>

						<a href='/Dashboard/evaluacion' id={"menuEvaluacion"}>
							<div className='icon_wrapper'>
								<svg
									width='12'
									height='12'
									viewBox='0 0 12 12'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_550592'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='12'
										height='12'
									>
										<rect width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_550592)'>
										<path
											d='M4.73709 6.27505L2.09959 8.91255C1.99126 9.02088 1.85793 9.07288 1.69959 9.06855C1.54126 9.06455 1.40793 9.00838 1.29959 8.90005C1.19126 8.78338 1.13509 8.65005 1.13109 8.50005C1.12676 8.35005 1.18293 8.21672 1.29959 8.10005L4.33709 5.06255C4.45376 4.94588 4.58709 4.88755 4.73709 4.88755C4.88709 4.88755 5.02043 4.94588 5.13709 5.06255L6.73709 6.66255L8.13709 5.07505C7.71209 4.58338 7.21826 4.19788 6.65559 3.91855C6.09326 3.63955 5.47043 3.50005 4.78709 3.50005C4.30376 3.50005 3.83709 3.57722 3.38709 3.73155C2.93709 3.88555 2.52043 4.10005 2.13709 4.37505C1.99543 4.47505 1.84326 4.52288 1.68059 4.51855C1.51826 4.51455 1.38709 4.44588 1.28709 4.31255C1.17876 4.16255 1.14543 4.00622 1.18709 3.84355C1.22876 3.68122 1.32459 3.54588 1.47459 3.43755C1.94959 3.09588 2.46626 2.83122 3.02459 2.64355C3.58293 2.45622 4.17043 2.36255 4.78709 2.36255C5.61209 2.36255 6.37676 2.52705 7.08109 2.85605C7.78509 3.18538 8.39543 3.64172 8.91209 4.22505L9.83709 3.16255C9.95376 3.03755 10.0934 2.97705 10.2561 2.98105C10.4184 2.98538 10.5579 3.03755 10.6746 3.13755C10.7746 3.24588 10.8288 3.37505 10.8371 3.52505C10.8454 3.67505 10.7954 3.80838 10.6871 3.92505L9.61209 5.13755C9.84543 5.49588 10.0393 5.87922 10.1936 6.28755C10.3476 6.69588 10.4621 7.12922 10.5371 7.58755C10.5704 7.75422 10.5393 7.90622 10.4436 8.04355C10.3476 8.18122 10.2079 8.25005 10.0246 8.25005C9.84126 8.25005 9.70159 8.20422 9.60559 8.11255C9.50993 8.02088 9.43709 7.87505 9.38709 7.67505C9.32876 7.38338 9.24959 7.09788 9.14959 6.81855C9.04959 6.53955 8.93293 6.27922 8.79959 6.03755L7.18709 7.85005C7.07876 7.97505 6.94126 8.03955 6.77459 8.04355C6.60793 8.04788 6.47043 7.99172 6.36209 7.87505L4.73709 6.27505Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>

							<p onClick={(e) => {
								window.location.pathname = '/Dashboard/evaluacion'
							}} id={"menuEvaluacionp"}>Evaluación de Promociones</p>
						</a>
						{ /*
						<Link to={'/CatalogSearch'}>
							<div className='icon_wrapper'>
								<svg
									width='12'
									height='12'
									viewBox='0 0 12 12'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_551309'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='12'
										height='12'
									>
										<rect width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_551309)'>
										<path
											d='M9.40034 10.2125L6.62534 7.43755C6.37534 7.62922 6.08784 7.78338 5.76284 7.90005C5.43784 8.01672 5.09201 8.07505 4.72534 8.07505C3.80034 8.07505 3.01701 7.75205 2.37534 7.10605C1.73368 6.46038 1.41284 5.67505 1.41284 4.75005C1.41284 3.82505 1.73368 3.03955 2.37534 2.39355C3.01701 1.74788 3.80034 1.42505 4.72534 1.42505C5.65034 1.42505 6.43584 1.74788 7.08184 2.39355C7.72751 3.03955 8.05034 3.82505 8.05034 4.75005C8.05034 5.11672 7.99417 5.46255 7.88184 5.78755C7.76917 6.11255 7.61701 6.39588 7.42534 6.63755L10.2128 9.43755C10.3128 9.53755 10.3628 9.66472 10.3628 9.81905C10.3628 9.97305 10.3087 10.1042 10.2003 10.2125C10.092 10.3209 9.95667 10.375 9.79434 10.375C9.63167 10.375 9.50034 10.3209 9.40034 10.2125ZM4.72534 6.92505C5.33368 6.92505 5.85034 6.71455 6.27534 6.29355C6.70034 5.87288 6.91284 5.35838 6.91284 4.75005C6.91284 4.14172 6.70034 3.62705 6.27534 3.20605C5.85034 2.78538 5.33368 2.57505 4.72534 2.57505C4.11701 2.57505 3.60251 2.78538 3.18184 3.20605C2.76084 3.62705 2.55034 4.14172 2.55034 4.75005C2.55034 5.35838 2.76084 5.87288 3.18184 6.29355C3.60251 6.71455 4.11701 6.92505 4.72534 6.92505Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>

							<p>Búsqueda de Catálogos</p>
						</Link>
						*/ }

						 <a href='/Dashboard/historial' id={"menuHistorial"}>
						 <div className='icon_wrapper'>
								<svg
									width='12'
									height='12'
									viewBox='0 0 12 12'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_551405'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='12'
										height='12'
									>
										<rect width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_551405)'>
										<path
											d='M3.46623 11.5258C3.15393 11.5199 2.88582 11.405 2.6619 11.1811C2.43798 10.9572 2.32308 10.6891 2.31719 10.3768L2.31719 4.15425C2.32308 4.00694 2.35407 3.86116 2.41017 3.71691C2.46603 3.57242 2.54994 3.4442 2.6619 3.33224L5.18981 0.804334C5.41372 0.580417 5.68195 0.468458 5.99449 0.468458C6.30656 0.468458 6.57456 0.580417 6.79847 0.804334L9.32638 3.33224C9.43834 3.4442 9.52237 3.5723 9.57846 3.71655C9.63433 3.86104 9.6652 4.00694 9.6711 4.15425L9.66226 10.3856C9.66226 10.692 9.5503 10.9572 9.32638 11.1811C9.10246 11.405 8.83435 11.5199 8.52205 11.5258H3.46623ZM3.4574 10.3856L8.51321 10.3856L8.52205 4.13657L5.99414 1.60867L3.46623 4.13657L3.4574 10.3856ZM5.46381 3.90676C5.61112 4.05408 5.7879 4.12762 5.99414 4.12738C6.20038 4.12762 6.37716 4.05408 6.52447 3.90676C6.67178 3.75945 6.74532 3.58267 6.74509 3.37643C6.74532 3.1702 6.67178 2.99342 6.52447 2.8461C6.37716 2.69879 6.20038 2.62525 5.99414 2.62549C5.7879 2.62525 5.61112 2.69879 5.46381 2.8461C5.3165 2.99342 5.24296 3.1702 5.24319 3.37643C5.24296 3.58267 5.3165 3.75945 5.46381 3.90676Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>

							<p onClick={(e) => {
								window.location.pathname = '/Dashboard/historial'
							}} id={"menuHistorialp"}>Historial de Promociones</p>
						</a>

						

						{/*	<a href='#'>
							<div className='icon_wrapper'>
								<svg
									width='12'
									height='12'
									viewBox='0 0 12 12'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_550281'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='12'
										height='12'
									>
										<rect width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_550281)'>
										<path
											d='M1.97529 9.5876C1.82529 9.5876 1.69613 9.5356 1.58779 9.4316C1.47946 9.32726 1.42529 9.2001 1.42529 9.0501C1.42529 8.89176 1.47946 8.76043 1.58779 8.6561C1.69613 8.5521 1.82529 8.5001 1.97529 8.5001H3.97529C4.13363 8.5001 4.26496 8.5521 4.36929 8.6561C4.47329 8.76043 4.52529 8.89176 4.52529 9.0501C4.52529 9.2001 4.47329 9.32726 4.36929 9.4316C4.26496 9.5356 4.13363 9.5876 3.97529 9.5876H1.97529ZM1.97529 3.5001C1.82529 3.5001 1.69613 3.4481 1.58779 3.3441C1.47946 3.23976 1.42529 3.10843 1.42529 2.9501C1.42529 2.8001 1.47946 2.67293 1.58779 2.5686C1.69613 2.4646 1.82529 2.4126 1.97529 2.4126H5.97529C6.13363 2.4126 6.26496 2.4646 6.36929 2.5686C6.47329 2.67293 6.52529 2.8001 6.52529 2.9501C6.52529 3.10843 6.47329 3.23976 6.36929 3.3441C6.26496 3.4481 6.13363 3.5001 5.97529 3.5001H1.97529ZM6.02529 10.5876C5.86696 10.5876 5.73579 10.5356 5.63179 10.4316C5.52746 10.3273 5.47529 10.2001 5.47529 10.0501V8.0501C5.47529 7.89176 5.52746 7.76043 5.63179 7.6561C5.73579 7.5521 5.86696 7.5001 6.02529 7.5001C6.17529 7.5001 6.30446 7.5521 6.41279 7.6561C6.52113 7.76043 6.57529 7.89176 6.57529 8.0501V8.5001H10.0253C10.1753 8.5001 10.3045 8.5521 10.4128 8.6561C10.5211 8.76043 10.5753 8.89176 10.5753 9.0501C10.5753 9.2001 10.5211 9.32726 10.4128 9.4316C10.3045 9.5356 10.1753 9.5876 10.0253 9.5876H6.57529V10.0501C6.57529 10.2001 6.52113 10.3273 6.41279 10.4316C6.30446 10.5356 6.17529 10.5876 6.02529 10.5876ZM3.97529 7.5501C3.82529 7.5501 3.69613 7.49793 3.58779 7.3936C3.47946 7.2896 3.42529 7.15843 3.42529 7.0001V6.5501H1.97529C1.82529 6.5501 1.69613 6.49793 1.58779 6.3936C1.47946 6.2896 1.42529 6.15843 1.42529 6.0001C1.42529 5.84176 1.47946 5.71043 1.58779 5.6061C1.69613 5.5021 1.82529 5.4501 1.97529 5.4501H3.42529V5.0001C3.42529 4.84176 3.47946 4.71043 3.58779 4.6061C3.69613 4.5021 3.82529 4.4501 3.97529 4.4501C4.13363 4.4501 4.26496 4.5021 4.36929 4.6061C4.47329 4.71043 4.52529 4.84176 4.52529 5.0001V7.0001C4.52529 7.15843 4.47329 7.2896 4.36929 7.3936C4.26496 7.49793 4.13363 7.5501 3.97529 7.5501ZM6.02529 6.5501C5.86696 6.5501 5.73579 6.49793 5.63179 6.3936C5.52746 6.2896 5.47529 6.15843 5.47529 6.0001C5.47529 5.84176 5.52746 5.71043 5.63179 5.6061C5.73579 5.5021 5.86696 5.4501 6.02529 5.4501H10.0253C10.1753 5.4501 10.3045 5.5021 10.4128 5.6061C10.5211 5.71043 10.5753 5.84176 10.5753 6.0001C10.5753 6.15843 10.5211 6.2896 10.4128 6.3936C10.3045 6.49793 10.1753 6.5501 10.0253 6.5501H6.02529ZM8.02529 4.5001C7.86696 4.5001 7.73579 4.4481 7.63179 4.3441C7.52746 4.23976 7.47529 4.10843 7.47529 3.9501V1.9501C7.47529 1.8001 7.52746 1.67293 7.63179 1.5686C7.73579 1.4646 7.86696 1.4126 8.02529 1.4126C8.17529 1.4126 8.30446 1.4646 8.41279 1.5686C8.52113 1.67293 8.57529 1.8001 8.57529 1.9501V2.4126H10.0253C10.1753 2.4126 10.3045 2.4646 10.4128 2.5686C10.5211 2.67293 10.5753 2.8001 10.5753 2.9501C10.5753 3.10843 10.5211 3.23976 10.4128 3.3441C10.3045 3.4481 10.1753 3.5001 10.0253 3.5001H8.57529V3.9501C8.57529 4.10843 8.52113 4.23976 8.41279 4.3441C8.30446 4.4481 8.17529 4.5001 8.02529 4.5001Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>

							<p>Mantenedores</p>
						</a> */}


						<a href='/Dashboard/panelmargenes' id={"menuHistorial"}>
						 <div className='icon_wrapper'>
								<svg
									width='12'
									height='12'
									viewBox='0 0 12 12'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_551405'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='12'
										height='12'
									>
										<rect width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_551405)'>
										<path
											d='M3.46623 11.5258C3.15393 11.5199 2.88582 11.405 2.6619 11.1811C2.43798 10.9572 2.32308 10.6891 2.31719 10.3768L2.31719 4.15425C2.32308 4.00694 2.35407 3.86116 2.41017 3.71691C2.46603 3.57242 2.54994 3.4442 2.6619 3.33224L5.18981 0.804334C5.41372 0.580417 5.68195 0.468458 5.99449 0.468458C6.30656 0.468458 6.57456 0.580417 6.79847 0.804334L9.32638 3.33224C9.43834 3.4442 9.52237 3.5723 9.57846 3.71655C9.63433 3.86104 9.6652 4.00694 9.6711 4.15425L9.66226 10.3856C9.66226 10.692 9.5503 10.9572 9.32638 11.1811C9.10246 11.405 8.83435 11.5199 8.52205 11.5258H3.46623ZM3.4574 10.3856L8.51321 10.3856L8.52205 4.13657L5.99414 1.60867L3.46623 4.13657L3.4574 10.3856ZM5.46381 3.90676C5.61112 4.05408 5.7879 4.12762 5.99414 4.12738C6.20038 4.12762 6.37716 4.05408 6.52447 3.90676C6.67178 3.75945 6.74532 3.58267 6.74509 3.37643C6.74532 3.1702 6.67178 2.99342 6.52447 2.8461C6.37716 2.69879 6.20038 2.62525 5.99414 2.62549C5.7879 2.62525 5.61112 2.69879 5.46381 2.8461C5.3165 2.99342 5.24296 3.1702 5.24319 3.37643C5.24296 3.58267 5.3165 3.75945 5.46381 3.90676Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>

							<p onClick={(e) => {
								window.location.pathname = '/Dashboard/panelmargenes'
							}} id={"menuHistorialp"}>Panel de Márgenes</p>
						</a>
						
						
						<a href='/Dashboard/forecastprecios' id={"menuForecast"}>
						 <div className='icon_wrapper'>
								<svg
									width='12'
									height='12'
									viewBox='0 0 12 12'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_551405'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='12'
										height='12'
									>
										<rect width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_551405)'>
										<path
											d='M3.46623 11.5258C3.15393 11.5199 2.88582 11.405 2.6619 11.1811C2.43798 10.9572 2.32308 10.6891 2.31719 10.3768L2.31719 4.15425C2.32308 4.00694 2.35407 3.86116 2.41017 3.71691C2.46603 3.57242 2.54994 3.4442 2.6619 3.33224L5.18981 0.804334C5.41372 0.580417 5.68195 0.468458 5.99449 0.468458C6.30656 0.468458 6.57456 0.580417 6.79847 0.804334L9.32638 3.33224C9.43834 3.4442 9.52237 3.5723 9.57846 3.71655C9.63433 3.86104 9.6652 4.00694 9.6711 4.15425L9.66226 10.3856C9.66226 10.692 9.5503 10.9572 9.32638 11.1811C9.10246 11.405 8.83435 11.5199 8.52205 11.5258H3.46623ZM3.4574 10.3856L8.51321 10.3856L8.52205 4.13657L5.99414 1.60867L3.46623 4.13657L3.4574 10.3856ZM5.46381 3.90676C5.61112 4.05408 5.7879 4.12762 5.99414 4.12738C6.20038 4.12762 6.37716 4.05408 6.52447 3.90676C6.67178 3.75945 6.74532 3.58267 6.74509 3.37643C6.74532 3.1702 6.67178 2.99342 6.52447 2.8461C6.37716 2.69879 6.20038 2.62525 5.99414 2.62549C5.7879 2.62525 5.61112 2.69879 5.46381 2.8461C5.3165 2.99342 5.24296 3.1702 5.24319 3.37643C5.24296 3.58267 5.3165 3.75945 5.46381 3.90676Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>

							<p onClick={(e) => {
								window.location.pathname = '/Dashboard/forecastprecios'
							}} id={"menuForecastp"}>Forecast Precios</p>
						</a>
						<a href='/Dashboard/preciosporsala' id={"menuPreciosPorSala"}>
						 <div className='icon_wrapper'>
								<svg
									width='12'
									height='12'
									viewBox='0 0 12 12'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_551405'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='12'
										height='12'
									>
										<rect width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_551405)'>
										<path
											d='M3.46623 11.5258C3.15393 11.5199 2.88582 11.405 2.6619 11.1811C2.43798 10.9572 2.32308 10.6891 2.31719 10.3768L2.31719 4.15425C2.32308 4.00694 2.35407 3.86116 2.41017 3.71691C2.46603 3.57242 2.54994 3.4442 2.6619 3.33224L5.18981 0.804334C5.41372 0.580417 5.68195 0.468458 5.99449 0.468458C6.30656 0.468458 6.57456 0.580417 6.79847 0.804334L9.32638 3.33224C9.43834 3.4442 9.52237 3.5723 9.57846 3.71655C9.63433 3.86104 9.6652 4.00694 9.6711 4.15425L9.66226 10.3856C9.66226 10.692 9.5503 10.9572 9.32638 11.1811C9.10246 11.405 8.83435 11.5199 8.52205 11.5258H3.46623ZM3.4574 10.3856L8.51321 10.3856L8.52205 4.13657L5.99414 1.60867L3.46623 4.13657L3.4574 10.3856ZM5.46381 3.90676C5.61112 4.05408 5.7879 4.12762 5.99414 4.12738C6.20038 4.12762 6.37716 4.05408 6.52447 3.90676C6.67178 3.75945 6.74532 3.58267 6.74509 3.37643C6.74532 3.1702 6.67178 2.99342 6.52447 2.8461C6.37716 2.69879 6.20038 2.62525 5.99414 2.62549C5.7879 2.62525 5.61112 2.69879 5.46381 2.8461C5.3165 2.99342 5.24296 3.1702 5.24319 3.37643C5.24296 3.58267 5.3165 3.75945 5.46381 3.90676Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>

							<p onClick={(e) => {
								window.location.pathname = '/Dashboard/preciosporsala'
							}} id={"menuPreciosPorSalap"}>Precios por Sala</p>
						</a>
						
						
					</div>
				)}
				<div className='left_logo_area'>
					<img src={newLogo} alt='' onClick={(e) => {
						window.location.href = '/HomeNew'
					}}
					style={{cursor: 'pointer'}}
					/>
				</div>
			</div>
			<div className='right_side'>
				{/* TODO notificaciones in progress */}
				{/* <div
					className={`nav_icon ${active === 'second' && 'active'}`}
					onClick={(e) => {
						setActive(active === 'second' ? false : 'second')
					}}
				>
					{active === 'second' ? (
						<svg
							width='15'
							height='19'
							viewBox='0 0 15 19'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								d='M1.01365 15.8112C0.734531 15.8112 0.495955 15.7128 0.297926 15.5159C0.0993084 15.319 0 15.0691 0 14.7662C0 14.4785 0.0993084 14.2361 0.297926 14.0393C0.495955 13.8424 0.734531 13.7439 1.01365 13.7439H1.82898V7.58756C1.82898 6.26996 2.20741 5.10381 2.96427 4.08911C3.72055 3.0744 4.701 2.40803 5.90563 2.08999V1.47662C5.90563 1.06771 6.04901 0.71938 6.33577 0.431628C6.62194 0.143876 6.96335 0 7.36 0C7.75665 0 8.09835 0.143876 8.38511 0.431628C8.67128 0.71938 8.81437 1.06771 8.81437 1.47662V2.08999C10.0337 2.40803 11.018 3.0744 11.7672 4.08911C12.5164 5.10381 12.891 6.26996 12.891 7.58756V13.7439H13.7063C14.0002 13.7439 14.2426 13.8424 14.4335 14.0393C14.6245 14.2361 14.72 14.4785 14.72 14.7662C14.72 15.0691 14.6245 15.319 14.4335 15.5159C14.2426 15.7128 14.0002 15.8112 13.7063 15.8112H1.01365ZM7.36 18.56C6.86052 18.56 6.43096 18.3783 6.07134 18.0148C5.71112 17.6513 5.53102 17.2121 5.53102 16.6972H9.18898C9.18898 17.2121 9.00917 17.6513 8.64954 18.0148C8.28933 18.3783 7.85948 18.56 7.36 18.56Z'
								fill='white'
							/>
						</svg>
					) : (
						<svg
							width='15'
							height='19'
							viewBox='0 0 15 19'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								d='M1.01365 15.8112C0.734531 15.8112 0.495955 15.7128 0.297926 15.5159C0.0993084 15.319 0 15.0691 0 14.7662C0 14.4785 0.0993084 14.2361 0.297926 14.0393C0.495955 13.8424 0.734531 13.7439 1.01365 13.7439H1.82898V7.58756C1.82898 6.26996 2.20741 5.10381 2.96427 4.08911C3.72055 3.0744 4.701 2.40803 5.90563 2.08999V1.47662C5.90563 1.06771 6.04901 0.71938 6.33577 0.431628C6.62194 0.143876 6.96335 0 7.36 0C7.75665 0 8.09835 0.143876 8.38511 0.431628C8.67128 0.71938 8.81437 1.06771 8.81437 1.47662V2.08999C10.0337 2.40803 11.018 3.0744 11.7672 4.08911C12.5164 5.10381 12.891 6.26996 12.891 7.58756V13.7439H13.7063C14.0002 13.7439 14.2426 13.8424 14.4335 14.0393C14.6245 14.2361 14.72 14.4785 14.72 14.7662C14.72 15.0691 14.6245 15.319 14.4335 15.5159C14.2426 15.7128 14.0002 15.8112 13.7063 15.8112H1.01365ZM7.36 18.56C6.86052 18.56 6.43096 18.3783 6.07134 18.0148C5.71112 17.6513 5.53102 17.2121 5.53102 16.6972H9.18898C9.18898 17.2121 9.00917 17.6513 8.64954 18.0148C8.28933 18.3783 7.85948 18.56 7.36 18.56ZM3.83425 13.7439H10.8857V7.58756C10.8857 6.58801 10.5405 5.73232 9.85006 5.02051C9.1596 4.30871 8.32958 3.9528 7.36 3.9528C6.39042 3.9528 5.5604 4.30871 4.86994 5.02051C4.17948 5.73232 3.83425 6.58801 3.83425 7.58756V13.7439Z'
								fill='#3676F5'
							/>
						</svg>
					)}
				</div>
				{active === 'second' && (
					<div className='menu_wrapper navigate_wrapper'>
						<h1 style={{marginBottom: 8}}>Notificaciones</h1>

						<NotificationBox
							firstClassName='green_wrapper'
							changeTextName='comentó'
							condition='comentó'
						/>

						<NotificationBox
							firstClassName='orange_wrapper'
							changeTextName='editó'
							condition='editó'
						/>

						<NotificationBox
							firstClassName='purple_wrapper'
							changeTextName='movió'
							condition='movió'
						/>

						<NotificationBox
							firstClassName='green_wrapper'
							changeTextName='comentó'
							condition='comentó'
						/>

						<h1 style={{color: '#616161', marginTop: 15, marginBottom: 2}}>
							Leídas
						</h1>

						<NotificationBox
							firstClassName='gray_wrapper'
							changeTextName='editó'
							condition='gray'
						/>

						<NotificationBox
							firstClassName='gray_wrapper'
							changeTextName='comentó'
							condition='gray'
						/>
					</div>
				)} */}
				<div
					className={`profile_btn_wrapper ${active === 'third' && 'active'}`}
					onClick={(e) => {
						setActive(active === 'third' ? false : 'third')
					}}
					id={"menuPerfil"}
				>
					<img src={avatarnew} alt='avatarnew' id={"menuPerfilImg"}/>
					<p id={"menuPerfilNombre"}>{localStorage.getItem("nameUser")+" "+localStorage.getItem("lastName")}</p>
					<svg
						width='16'
						height='16'
						viewBox='0 0 16 16'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
						id={"menuPerfilSvg"}
					>
						<mask
							id='mask0_552_306041'
							maskUnits='userSpaceOnUse'
							x='2'
							y='2'
							width='12'
							height='12'
						>
							<rect x='2' y='2' width='12' height='12' fill='#D9D9D9' />
						</mask>
						<g mask='url(#mask0_552_306041)' id={"menuPerfilFlecha"}>
							<path
								d='M5.52488 12.6C5.39154 12.4583 5.32488 12.2937 5.32488 12.106C5.32488 11.9187 5.39154 11.7542 5.52488 11.6125L9.13738 8L5.51238 4.375C5.37904 4.24167 5.31238 4.07917 5.31238 3.8875C5.31238 3.69583 5.38321 3.52917 5.52488 3.3875C5.65821 3.25417 5.82071 3.1875 6.01238 3.1875C6.20404 3.1875 6.37071 3.25417 6.51238 3.3875L10.7124 7.6C10.7707 7.65833 10.8124 7.72083 10.8374 7.7875C10.8624 7.85417 10.8749 7.925 10.8749 8C10.8749 8.075 10.8624 8.14583 10.8374 8.2125C10.8124 8.27917 10.7707 8.34167 10.7124 8.4L6.49988 12.6125C6.36654 12.7458 6.20604 12.8125 6.01838 12.8125C5.83104 12.8125 5.66654 12.7417 5.52488 12.6Z'
								fill='#3676F5'
							/>
						</g>
					</svg>
				</div>

				{active === 'third' && (
					<div className='profile_options_new' style={{textAlign: 'right', width: '180px'}}>
						{/* <a href='#'>
							<div className='icon_wrapper'>
								<svg
									width='16'
									height='16'
									viewBox='0 0 16 16'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_570308'
										maskUnits='userSpaceOnUse'
										x='2'
										y='2'
										width='12'
										height='12'
									>
										<rect x='2' y='2' width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_570308)'>
										<path
											d='M8.00015 13.0999C7.30015 13.0999 6.63981 12.9666 6.01915 12.6999C5.39815 12.4332 4.85648 12.0707 4.39415 11.6124C3.93148 11.1541 3.56681 10.6146 3.30015 9.9939C3.03348 9.3729 2.90015 8.70824 2.90015 7.9999C2.90015 7.29157 3.03348 6.6269 3.30015 6.0059C3.56681 5.38524 3.93148 4.84574 4.39415 4.3874C4.85648 3.92907 5.39815 3.56657 6.01915 3.2999C6.63981 3.03324 7.30015 2.8999 8.00015 2.8999C8.70848 2.8999 9.37315 3.03324 9.99415 3.2999C10.6148 3.56657 11.1543 3.92907 11.6126 4.3874C12.071 4.84574 12.4335 5.38524 12.7001 6.0059C12.9668 6.6269 13.1001 7.29157 13.1001 7.9999C13.1001 8.70824 12.9668 9.3729 12.7001 9.9939C12.4335 10.6146 12.071 11.1541 11.6126 11.6124C11.1543 12.0707 10.6148 12.4332 9.99415 12.6999C9.37315 12.9666 8.70848 13.0999 8.00015 13.0999ZM6.56265 11.6874L7.13765 10.3874C6.77931 10.2541 6.47098 10.0561 6.21265 9.7934C5.95431 9.53107 5.75431 9.22074 5.61265 8.8624L4.30015 9.4124C4.49181 9.9374 4.78565 10.3999 5.18165 10.7999C5.57731 11.1999 6.03765 11.4957 6.56265 11.6874ZM5.61265 7.1374C5.75431 6.77907 5.95431 6.46857 6.21265 6.2059C6.47098 5.94357 6.77931 5.74574 7.13765 5.6124L6.58765 4.2999C6.05431 4.4999 5.58981 4.7999 5.19415 5.1999C4.79815 5.5999 4.50015 6.0624 4.30015 6.5874L5.61265 7.1374ZM8.00015 9.3999C8.39181 9.3999 8.72315 9.2644 8.99415 8.9934C9.26481 8.72274 9.40015 8.39157 9.40015 7.9999C9.40015 7.60824 9.26481 7.2769 8.99415 7.0059C8.72315 6.73524 8.39181 6.5999 8.00015 6.5999C7.60848 6.5999 7.27731 6.73524 7.00665 7.0059C6.73565 7.2769 6.60015 7.60824 6.60015 7.9999C6.60015 8.39157 6.73565 8.72274 7.00665 8.9934C7.27731 9.2644 7.60848 9.3999 8.00015 9.3999ZM9.43765 11.6874C9.96265 11.4957 10.421 11.2021 10.8126 10.8064C11.2043 10.4104 11.5001 9.95407 11.7001 9.4374L10.3876 8.8624C10.2626 9.22074 10.069 9.5269 9.80665 9.7809C9.54398 10.0352 9.23765 10.2374 8.88765 10.3874L9.43765 11.6874ZM10.3876 7.1124L11.7001 6.5624C11.5001 6.0374 11.2023 5.57907 10.8066 5.1874C10.4106 4.79574 9.95431 4.4999 9.43765 4.2999L8.88765 5.6374C9.23765 5.7624 9.53981 5.95407 9.79415 6.2124C10.0481 6.47074 10.246 6.77074 10.3876 7.1124Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>
							<p>Ayuda y Soporte Técnico</p>
						</a> */}

						{/* <a href='#'>
							<div className='icon_wrapper'>
								<svg
									width='12'
									height='12'
									viewBox='0 0 12 12'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_201_633574'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='12'
										height='12'
									>
										<rect width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_201_633574)'>
										<path
											d='M5.00015 5.95C4.41681 5.95 3.92098 5.74367 3.51265 5.331C3.10431 4.91867 2.90015 4.425 2.90015 3.85C2.90015 3.26667 3.10431 2.77083 3.51265 2.3625C3.92098 1.95417 4.41681 1.75 5.00015 1.75C5.58348 1.75 6.07931 1.95417 6.48765 2.3625C6.89598 2.77083 7.10015 3.26667 7.10015 3.85C7.10015 4.425 6.89598 4.91867 6.48765 5.331C6.07931 5.74367 5.58348 5.95 5.00015 5.95ZM1.46265 10.15C1.30431 10.15 1.17098 10.0958 1.06265 9.9875C0.954313 9.87917 0.900146 9.74583 0.900146 9.5875V8.65C0.900146 8.34167 0.979313 8.0605 1.13765 7.8065C1.29598 7.55217 1.50015 7.3625 1.75015 7.2375C2.17515 7.02083 2.66265 6.83533 3.21265 6.681C3.76265 6.527 4.35848 6.45 5.00015 6.45H5.20015C5.26681 6.45 5.32931 6.45833 5.38765 6.475C5.32098 6.625 5.25648 6.802 5.19415 7.006C5.13148 7.21033 5.08348 7.40417 5.05015 7.5875H5.01265C4.42931 7.5875 3.90431 7.6605 3.43765 7.8065C2.97098 7.95217 2.58765 8.1 2.28765 8.25C2.21265 8.29167 2.15231 8.34783 2.10665 8.4185C2.06065 8.4895 2.03765 8.57083 2.03765 8.6625V9.0125H5.15015C5.20015 9.2125 5.27731 9.4125 5.38165 9.6125C5.48565 9.8125 5.59181 9.99167 5.70015 10.15H1.46265ZM5.00015 4.8125C5.26681 4.8125 5.49398 4.71867 5.68165 4.531C5.86898 4.34367 5.96265 4.11667 5.96265 3.85C5.96265 3.58333 5.86898 3.35617 5.68165 3.1685C5.49398 2.98117 5.26681 2.8875 5.00015 2.8875C4.73348 2.8875 4.50648 2.98117 4.31915 3.1685C4.13148 3.35617 4.03765 3.58333 4.03765 3.85C4.03765 4.11667 4.13148 4.34367 4.31915 4.531C4.50648 4.71867 4.73348 4.8125 5.00015 4.8125ZM8.58765 9.0375C8.85431 9.0375 9.08348 8.94167 9.27515 8.75C9.46681 8.55833 9.56265 8.325 9.56265 8.05C9.56265 7.78333 9.46681 7.55417 9.27515 7.3625C9.08348 7.17083 8.85431 7.075 8.58765 7.075C8.31265 7.075 8.07931 7.17083 7.88765 7.3625C7.69598 7.55417 7.60015 7.78333 7.60015 8.05C7.60015 8.325 7.69598 8.55833 7.88765 8.75C8.07931 8.94167 8.31265 9.0375 8.58765 9.0375ZM7.88765 9.8375C7.79598 9.79583 7.70848 9.75417 7.62515 9.7125C7.54181 9.67083 7.45848 9.61667 7.37515 9.55L6.85015 9.7125C6.78348 9.7375 6.72098 9.7375 6.66265 9.7125C6.60431 9.6875 6.55848 9.64583 6.52515 9.5875L6.21265 9.075C6.17931 9.01667 6.16898 8.95417 6.18165 8.8875C6.19398 8.82083 6.22931 8.7625 6.28765 8.7125L6.68765 8.3625C6.67098 8.25417 6.66265 8.152 6.66265 8.056C6.66265 7.96033 6.67098 7.85833 6.68765 7.75L6.28765 7.4C6.22931 7.35 6.19398 7.29167 6.18165 7.225C6.16898 7.15833 6.17931 7.09583 6.21265 7.0375L6.52515 6.525C6.55848 6.46667 6.60431 6.425 6.66265 6.4C6.72098 6.375 6.78348 6.375 6.85015 6.4L7.37515 6.55C7.45848 6.49167 7.54181 6.4395 7.62515 6.3935C7.70848 6.34783 7.79598 6.30833 7.88765 6.275L8.00015 5.7375C8.01681 5.67083 8.05015 5.61667 8.10015 5.575C8.15015 5.53333 8.20848 5.5125 8.27515 5.5125H8.88765C8.95431 5.5125 9.01265 5.53333 9.06265 5.575C9.11265 5.61667 9.14598 5.67083 9.16265 5.7375L9.27515 6.275C9.36681 6.30833 9.45431 6.35 9.53765 6.4C9.62098 6.45 9.70431 6.50833 9.78765 6.575L10.3001 6.4C10.3668 6.36667 10.4315 6.3645 10.4941 6.3935C10.5565 6.42283 10.6085 6.46667 10.6501 6.525L10.9501 7.0625C10.9835 7.12083 10.996 7.18333 10.9876 7.25C10.9793 7.31667 10.946 7.375 10.8876 7.425L10.4751 7.775C10.5001 7.86667 10.5106 7.9645 10.5066 8.0685C10.5023 8.17283 10.4918 8.27083 10.4751 8.3625L10.8876 8.7125C10.9376 8.7625 10.971 8.82083 10.9876 8.8875C11.0043 8.95417 10.9918 9.01667 10.9501 9.075L10.6501 9.5875C10.6085 9.64583 10.5585 9.6875 10.5001 9.7125C10.4418 9.7375 10.3793 9.7375 10.3126 9.7125L9.78765 9.55C9.70431 9.61667 9.62098 9.67083 9.53765 9.7125C9.45431 9.75417 9.36681 9.79583 9.27515 9.8375L9.16265 10.375C9.14598 10.4417 9.11265 10.4958 9.06265 10.5375C9.01265 10.5792 8.95431 10.6 8.88765 10.6H8.27515C8.20848 10.6 8.15015 10.5792 8.10015 10.5375C8.05015 10.4958 8.01681 10.4417 8.00015 10.375L7.88765 9.8375Z'
											fill='#3676F5'
										/>
									</g>
								</svg>
							</div>

							<p>Configuración de Perfil</p>
						</a> */}

<a
    href='#'
    style={{ marginTop: '4px', display: 'flex', alignItems: 'center' }}
    onClick={async (e) => {
        e.preventDefault();
        e.stopPropagation(); // Evita que el menú se cierre antes del logout
		setActive(false);
        try {
            await logout();
            if (!authState.logged) {
                window.location.pathname = '/LoginNew';
            }
        } catch (error) {
            console.error("Error al cerrar sesión:", error);
        }
		window.location.pathname = '/LoginNew';
         // Cerrar menú solo después del logout
    }}
>
    <p id="cierreSesionMenu">Cerrar Sesión</p>
	<div className='icon_wrapper' style={{ marginLeft: '8px' }}>
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<mask
				id='mask0_201_632445'
				maskUnits='userSpaceOnUse'
				x='2'
				y='2'
				width='12'
				height='12'
			>
				<rect x='2' y='2' width='12' height='12' fill='#D9D9D9' />
			</mask>
			<g mask='url(#mask0_201_632445)'>
				<path
					d='M6.52444 10.2374C6.41611 10.1124 6.36194 9.97274 6.36194 9.8184C6.36194 9.6644 6.41611 9.53324 6.52444 9.4249L7.37444 8.5749H3.92444C3.76611 8.5749 3.63277 8.51857 3.52444 8.4059C3.41611 8.29357 3.36194 8.15824 3.36194 7.9999C3.36194 7.84157 3.41611 7.70624 3.52444 7.5939C3.63277 7.48124 3.76611 7.4249 3.92444 7.4249H7.37444L6.52444 6.5749C6.40777 6.45824 6.34944 6.32274 6.34944 6.1684C6.34944 6.0144 6.40777 5.87907 6.52444 5.7624C6.62444 5.65407 6.75361 5.5999 6.91194 5.5999C7.07027 5.5999 7.20361 5.65407 7.31194 5.7624L9.14944 7.5999C9.20777 7.65824 9.24944 7.72074 9.27444 7.7874C9.29944 7.85407 9.31194 7.9249 9.31194 7.9999C9.31194 8.0749 9.29944 8.14574 9.27444 8.2124C9.24944 8.27907 9.20777 8.34157 9.14944 8.3999L7.29944 10.2499C7.19111 10.3582 7.05977 10.4082 6.90544 10.3999C6.75144 10.3916 6.62444 10.3374 6.52444 10.2374ZM8.54944 12.5999C8.38277 12.5999 8.24527 12.5457 8.13694 12.4374C8.0286 12.3291 7.97444 12.1957 7.97444 12.0374C7.97444 11.8707 8.0286 11.7332 8.13694 11.6249C8.24527 11.5166 8.38277 11.4624 8.54944 11.4624H11.4994V4.5374H8.54944C8.38277 4.5374 8.24527 4.48324 8.13694 4.3749C8.0286 4.26657 7.97444 4.12907 7.97444 3.9624C7.97444 3.80407 8.0286 3.67074 8.13694 3.5624C8.24527 3.45407 8.38277 3.3999 8.54944 3.3999H11.4994C11.8161 3.3999 12.0849 3.51024 12.3059 3.7309C12.5266 3.9519 12.6369 4.22074 12.6369 4.5374V11.4624C12.6369 11.7791 12.5266 12.0479 12.3059 12.2689C12.0849 12.4896 11.8161 12.5999 11.4994 12.5999H8.54944Z'
					fill='#3676F5'
				/>
			</g>
		</svg>
	</div>
</a>

					</div>
				)}
			</div>
		</div>
	)
}
